(() => {
  const match = location.pathname.match(/\/products\/([^/?#]+)/);
  const handle = match ? match[1] : '';
  if (!window.SmoofProductProfiles?.isTestProfile?.(handle)) return;
  if (window.__smoofBackgroundGradientV19) return;
  window.__smoofBackgroundGradientV19 = true;

  const PROPERTIES = {
    enabled: 'properties[_SMOOF Hintergrund Verlauf aktiv]',
    color1: 'properties[_SMOOF Hintergrund Verlauf Farbe 1]',
    color2: 'properties[_SMOOF Hintergrund Verlauf Farbe 2]',
    angle: 'properties[_SMOOF Hintergrund Verlauf Winkel]',
    overlayEnabled: 'properties[_SMOOF Hintergrund Overlay aktiv]',
    overlayColor: 'properties[_SMOOF Hintergrund Overlay Farbe]',
    overlayOpacity: 'properties[_SMOOF Hintergrund Overlay Deckkraft]'
  };

  const BACKGROUND_OPTION_ID = 'dcde59d1-5fef-4e99-8d22-30e2ec19197e';
  const PRODUCT_DEFAULT_BASE_COLOR = '#c0c0c0';

  const state = {
    enabled: false,
    color1: '#000000',
    color2: '#ffffff',
    angle: 0,
    overlayEnabled: false,
    overlayColor: '#000000',
    overlayOpacity: 0.3
  };

  let hydrated = false;
  let renderPending = false;

  function productForm() {
    return Array.from(document.querySelectorAll('form[action*="/cart/add"]'))
      .find(form => form.querySelector('button[type="submit"]')) || null;
  }

  function normalizeColor(value, fallback = '#000000') {
    const text = String(value || '').trim();
    if (/^#[0-9a-f]{6}$/i.test(text)) return text.toLowerCase();
    if (/^#[0-9a-f]{8}$/i.test(text)) return text.slice(0, 7).toLowerCase();
    if (/^#[0-9a-f]{3}$/i.test(text)) {
      return `#${text.slice(1).split('').map(character => character.repeat(2)).join('')}`.toLowerCase();
    }
    return fallback;
  }

  function backgroundRoot() {
    return window.SmoofProductMaster?.fieldRoot?.('backgroundColor') ||
      document.querySelector(`[data-option-id="${BACKGROUND_OPTION_ID}"]`);
  }

  function baseColorControls() {
    return Array.from(backgroundRoot()?.querySelectorAll('input') || [])
      .filter(input => {
        const type = String(input.type || '').toLowerCase();
        return ['color', 'text', 'hidden'].includes(type) &&
          /^#[0-9a-f]{3,8}$/i.test(String(input.value || '').trim());
      });
  }

  function setNativeInputValue(input, value) {
    const descriptor = Object.getOwnPropertyDescriptor(
      HTMLInputElement.prototype,
      'value'
    );
    if (descriptor?.set) descriptor.set.call(input, value);
    else input.value = value;
  }

  function writeBaseColor(value) {
    const color = normalizeColor(value, PRODUCT_DEFAULT_BASE_COLOR);
    const controls = baseColorControls();

    controls.forEach(input => {
      if (normalizeColor(input.value, '') === color) return;
      setNativeInputValue(input, color);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    const layer = document.querySelector('[data-smoof-background-color]');
    if (layer) layer.style.backgroundColor = color;
    return color;
  }

  function normalizeAngle(value) {
    const number = Number.parseFloat(value);
    if (!Number.isFinite(number)) return 0;
    return ((Math.round(number) % 360) + 360) % 360;
  }

  function normalizeOpacity(value, fallback = 0.3) {
    const number = Number.parseFloat(value);
    return Number.isFinite(number) ? Math.max(0, Math.min(1, number)) : fallback;
  }

  function currentBaseColor() {
    const input = baseColorControls().find(control => control.type === 'color') ||
      baseColorControls()[0];
    return normalizeColor(input?.value, PRODUCT_DEFAULT_BASE_COLOR);
  }

  function existingProperty(form, name) {
    return Array.from(form?.querySelectorAll('input') || [])
      .find(input => input.name === name) || null;
  }

  function hydrate() {
    if (hydrated) return;
    const form = productForm();
    if (!form) return;

    const enabled = existingProperty(form, PROPERTIES.enabled);
    const color1 = existingProperty(form, PROPERTIES.color1);
    const color2 = existingProperty(form, PROPERTIES.color2);
    const angle = existingProperty(form, PROPERTIES.angle);
    const overlayEnabled = existingProperty(form, PROPERTIES.overlayEnabled);
    const overlayColor = existingProperty(form, PROPERTIES.overlayColor);
    const overlayOpacity = existingProperty(form, PROPERTIES.overlayOpacity);

    state.enabled = /^(true|1|ja|yes)$/i.test(enabled?.value || '');
    state.color1 = normalizeColor(color1?.value, currentBaseColor());
    state.color2 = normalizeColor(color2?.value, '#ffffff');
    state.angle = normalizeAngle(angle?.value);
    state.overlayEnabled = /^(true|1|ja|yes)$/i.test(overlayEnabled?.value || '');
    state.overlayColor = normalizeColor(overlayColor?.value, '#000000');
    state.overlayOpacity = normalizeOpacity(overlayOpacity?.value, 0.3);
    hydrated = true;
  }

  function ensureProperty(form, name) {
    let input = existingProperty(form, name);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.dataset.smoofBackgroundGradientProperty = 'true';
      form.appendChild(input);
    }
    return input;
  }

  function syncProperties() {
    hydrate();
    const form = productForm();
    if (!form || !hydrated) return;
    ensureProperty(form, PROPERTIES.enabled).value = String(state.enabled);
    ensureProperty(form, PROPERTIES.color1).value = state.color1;
    ensureProperty(form, PROPERTIES.color2).value = state.color2;
    ensureProperty(form, PROPERTIES.angle).value = String(state.angle);
    ensureProperty(form, PROPERTIES.overlayEnabled).value = String(state.overlayEnabled);
    ensureProperty(form, PROPERTIES.overlayColor).value = state.overlayColor;
    ensureProperty(form, PROPERTIES.overlayOpacity).value = String(state.overlayOpacity);
  }

  function cssGradient() {
    return state.enabled
      ? `linear-gradient(${state.angle}deg, ${state.color1} 0%, ${state.color2} 100%)`
      : 'none';
  }

  function applyVisual() {
    hydrate();
    syncProperties();
    const layer = document.querySelector('[data-smoof-background-color]');
    if (layer) {
      layer.style.backgroundImage = cssGradient();
      layer.dataset.smoofBackgroundGradient = String(state.enabled);
    }
    const imageLayer = document.querySelector('[data-smoof-background-image]');
    const hasImage = Boolean(
      window.SmoofBackgroundImageBridge?.getState?.()?.hasImage ||
      window.SmoofBackgroundImageTools?.getState?.()?.hasImage
    );
    const overlayHost = (hasImage ? imageLayer : layer) || imageLayer;
    if (overlayHost) {
      let overlay = document.querySelector('[data-smoof-background-overlay]');
      if (!overlay) {
        overlay = document.createElement('span');
        overlay.dataset.smoofBackgroundOverlay = 'true';
        overlay.setAttribute('aria-hidden', 'true');
      }
      if (overlay.parentElement !== overlayHost) overlayHost.appendChild(overlay);
      Object.assign(overlay.style, {
        position: 'absolute',
        inset: '0',
        display: state.overlayEnabled && state.overlayOpacity > 0 ? 'block' : 'none',
        backgroundColor: state.overlayColor,
        opacity: String(state.overlayOpacity),
        borderRadius: 'inherit',
        pointerEvents: 'none',
        zIndex: '1'
      });
    }
    window.SmoofDesignRenderer?.scheduleRender?.();
  }

  function notify() {
    applyVisual();
    window.dispatchEvent(new CustomEvent('smoof:background-gradient-changed', {
      detail: { ...state }
    }));
  }

  function scheduleRender() {
    if (renderPending) return;
    renderPending = true;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        renderPending = false;
        applyVisual();
      });
    });
  }

  function setEnabled(value) {
    state.enabled = Boolean(value);
    notify();
  }

  function setColor(kind, value) {
    const key = kind === 'end' || kind === 'color2' ? 'color2' : 'color1';
    state[key] = normalizeColor(value, state[key]);
    notify();
  }

  function setAngle(value) {
    state.angle = normalizeAngle(value);
    notify();
  }

  function setOverlayEnabled(value) {
    state.overlayEnabled = Boolean(value);
    notify();
  }

  function setOverlayColor(value) {
    state.overlayColor = normalizeColor(value, state.overlayColor);
    notify();
  }

  function setOverlayOpacity(value) {
    state.overlayOpacity = normalizeOpacity(value, state.overlayOpacity);
    notify();
  }

  function reset() {
    state.enabled = false;
    state.color1 = currentBaseColor();
    state.color2 = '#ffffff';
    state.angle = 0;
    state.overlayEnabled = false;
    state.overlayColor = '#000000';
    state.overlayOpacity = 0.3;
    notify();
  }

  function resetBackground() {
    const baseColor = writeBaseColor(PRODUCT_DEFAULT_BASE_COLOR);
    state.enabled = false;
    state.color1 = baseColor;
    state.color2 = '#ffffff';
    state.angle = 0;
    state.overlayEnabled = false;
    state.overlayColor = '#000000';
    state.overlayOpacity = 0.3;
    window.SmoofBackgroundImageTools?.remove?.();
    notify();

    /*
     * Easify baut seine Farbeingabe beim Komplett-Reset asynchron neu auf.
     * Die erneute Korrektur stellt sicher, dass weder ein alter React-Wert
     * noch der frühere schwarze Fallback nach dem Re-Render zurückkehrt.
     */
    [0, 80, 240].forEach(delay => {
      window.setTimeout(() => {
        state.color1 = writeBaseColor(PRODUCT_DEFAULT_BASE_COLOR);
        applyVisual();
      }, delay);
    });
  }

  function getState() {
    hydrate();
    return { ...state };
  }

  window.SmoofBackgroundGradientTools = Object.freeze({
    getState,
    getHistoryState: getState,
    setEnabled,
    toggle() {
      setEnabled(!state.enabled);
    },
    setColor,
    setAngle,
    setOverlayEnabled,
    toggleOverlay() {
      setOverlayEnabled(!state.overlayEnabled);
    },
    setOverlayColor,
    setOverlayOpacity,
    reset,
    applyHistoryState(saved) {
      if (!saved) return;
      state.enabled = Boolean(saved.enabled);
      state.color1 = normalizeColor(saved.color1, currentBaseColor());
      state.color2 = normalizeColor(saved.color2, '#ffffff');
      state.angle = normalizeAngle(saved.angle);
      state.overlayEnabled = Boolean(saved.overlayEnabled);
      state.overlayColor = normalizeColor(saved.overlayColor, '#000000');
      state.overlayOpacity = normalizeOpacity(saved.overlayOpacity, 0.3);
      notify();
    }
  });

  document.addEventListener('input', scheduleRender, true);
  document.addEventListener('change', scheduleRender, true);
  window.addEventListener('smoof:editor-reset-all', resetBackground);
  window.addEventListener('smoof:editor-reset-content', resetBackground);

  new MutationObserver(scheduleRender).observe(document.body, {
    childList: true,
    subtree: true
  });

  window.setInterval(scheduleRender, 500);
  scheduleRender();
})();
